module.exports = __webpack_public_path__ + "img/phoenix.06789888.png";